import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'gatsby'

import './linked_list.scss'

export const LinkedList = ({ items, ...props }) => {
  return (
    <div className="linked-list-container">
      <Row className="linked-list">
        {items.map(({ content, path }, index) => {
          return (
            <Col key={index} sm={6} md={4} className="mb-4">
              <div className="linked-list-item-container d-flex justify-content-center align-items-center">
                <div>
                  <Link to={path} className="linked-list-item">
                    {content}
                  </Link>
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
